const headermenus = [
  {
    content: {
      footwear: {
        featuredBrands: {
          children: [
            {
              children: [
                { name: 'Air Force 1', slug: 'air-force-1', type: 'link' },
                { name: 'Air Huarache', slug: 'air-huarache', type: 'link' },
                { name: 'Air Max 1', slug: 'air-max-1', type: 'link' },
                { name: 'Air Max 90', slug: 'air-max-90', type: 'link' },
                { name: 'Air Max 95', slug: 'air-max-95', type: 'link' },
                { name: 'Air Max 97', slug: 'air-max-97', type: 'link' },
                { name: 'Blazer', slug: 'blazer', type: 'link' },
                { name: 'Dunk', slug: 'dunk', type: 'link' },
                {
                  name: 'TN Air Max Plus',
                  slug: 'tn-air-max-plus',
                  type: 'link'
                },
                { name: 'P-6000', slug: 'p-6000', type: 'link' },
                { name: 'Shox', slug: 'shox', type: 'link' },
                { name: 'Vomero', slug: 'zoom-vomero', type: 'link' }
              ],
              icon: 'nike',
              name: 'Nike',
              path: '/release-dates/nike/',
              slug: 'nike',
              viewAll: {
                label: 'View all Nike',
                link: ''
              }
            },
            {
              children: [
                { name: 'Air Jordan 1', slug: 'air-jordan-1', type: 'link' },
                {
                  name: 'Air Jordan 11',
                  slug: 'air-jordan-11',
                  type: 'link'
                },
                {
                  name: 'Air Jordan 12',
                  slug: 'air-jordan-12',
                  type: 'link'
                },
                {
                  name: 'Air Jordan 13',
                  slug: 'air-jordan-13',
                  type: 'link'
                },
                { name: 'Air Jordan 2', slug: 'air-jordan-2', type: 'link' },
                { name: 'Air Jordan 3', slug: 'air-jordan-3', type: 'link' },
                { name: 'Air Jordan 4', slug: 'air-jordan-4', type: 'link' },
                { name: 'Air Jordan 5', slug: 'air-jordan-5', type: 'link' },
                { name: 'Air Jordan 6', slug: 'air-jordan-6', type: 'link' },
                { name: 'Air Jordan 7', slug: 'air-jordan-7', type: 'link' },
                {
                  name: 'Air Jordan Spizike',
                  slug: 'air-jordan-spizike',
                  type: 'link'
                }
              ],
              icon: 'jordan',
              name: 'Jordan',
              path: '/release-dates/nike/',
              slug: 'jordan',
              viewAll: {
                label: 'View all Jordan',
                link: 'jordan/'
              }
            },
            {
              children: [
                { name: 'Adizero', slug: 'adizero', type: 'link' },
                { name: 'Campus', slug: 'campus', type: 'link' },
                { name: 'City Series', slug: 'city-series', type: 'link' },
                { name: 'Gazelle', slug: 'gazelle', type: 'link' },
                { name: 'NMD', slug: 'nmd', type: 'link' },
                { name: 'Samba', slug: 'samba', type: 'link' },
                { name: 'SL 72', slug: 'sl72', type: 'link' },
                { name: 'Spezial', slug: 'spezial', type: 'link' },
                { name: 'Stan Smith', slug: 'stan-smith', type: 'link' },
                { name: 'Superstar', slug: 'superstar', type: 'link' },
                { name: 'Ultraboost', slug: 'ultraboost', type: 'link' }
              ],
              icon: 'adidas',
              name: 'adidas',
              path: '/release-dates/adidas/',
              slug: 'adidas',
              viewAll: {
                label: 'View all adidas',
                link: ''
              }
            },
            {
              children: [
                { name: '450', slug: '450', type: 'link' },
                { name: '500', slug: '500', type: 'link' },
                { name: 'Boost 350', slug: 'boost-350', type: 'link' },
                { name: 'Boost 380', slug: 'boost-380', type: 'link' },
                { name: 'Boost 700', slug: 'boost-700', type: 'link' },
                { name: 'Boot', slug: 'boot', type: 'link' },
                { name: 'Foam Runner', slug: 'foam-runner', type: 'link' },
                { name: 'Quantum', slug: 'quantum', type: 'link' },
                { name: 'Slides', slug: 'slide', type: 'link' }
              ],
              icon: 'yeezy',
              name: 'Yeezy',
              path: '/release-dates/yeezy/',
              slug: 'yeezy',
              viewAll: {
                label: 'View all Yeezy',
                link: ''
              }
            },
            {
              children: [
                { name: '327', slug: '327', type: 'link' },
                { name: '530', slug: '530', type: 'link' },
                { name: '550', slug: '550', type: 'link' },
                { name: '574', slug: '574', type: 'link' },
                { name: '740', slug: '740', type: 'link' },
                { name: '990', slug: '990', type: 'link' },
                { name: '991', slug: '991', type: 'link' },
                { name: '1000', slug: '1000', type: 'link' },
                { name: '9060', slug: '9060', type: 'link' },
                { name: '1906R', slug: '1906r', type: 'link' },
                { name: '2002R', slug: '2002r', type: 'link' },
                {
                  name: 'Protection Pack',
                  slug: 'protection-pack',
                  type: 'link'
                }
              ],
              icon: 'newBalance',
              name: 'New Balance',
              path: '/release-dates/new-balance/',
              slug: 'new-balance',
              viewAll: {
                label: 'View all New Balance',
                link: ''
              }
            },
            {
              children: [
                {
                  name: 'Classic Boots',
                  slug: 'ultra-mini-boots',
                  type: 'link'
                },
                { name: 'Goldenstar', slug: 'goldenstar', type: 'link' },
                { name: 'Lowmel', slug: 'lowmel', type: 'link' },
                { name: 'Tasman', slug: 'tasman', type: 'link' },
                { name: 'Tazz', slug: 'tazz', type: 'link' }
              ],
              icon: 'ugg',
              name: 'UGG',
              path: '/release-dates/ugg/',
              slug: 'ugg',
              viewAll: {
                label: 'View all UGGs',
                link: ''
              }
            }
          ]
        },
        filters: [
          {
            link: '/release-dates/',
            title: "What's hot"
          },
          {
            link: '/release-dates/?sort=LATEST_RELEASES',
            title: 'Latest releases'
          },
          {
            link: '/release-dates/?sort=UPCOMING_RELEASES',
            title: 'Upcoming releases'
          }
        ],
        icon: 'footwear',
        title: 'Footwear',
        viewAll: {
          link: '/brands/',
          title: 'view all brands'
        }
      },
      render: true
    },
    link: '/release-dates/',
    name: 'Footwear',
    slug: 'release-dates'
  },
  {
    link: '/sole-market/',
    name: 'Marketplace',
    slug: 'marketplace'
  },
  {
    content: {
      footwear: {
        featuredBrands: {
          children: [
            {
              icon: 'adidas',
              name: 'adidas',
              path: '/clothing/adidas/',
              type: 'brand'
            },
            {
              icon: 'carhartt',
              name: 'Carhartt',
              path: '/clothing/carhartt/',
              type: 'brand'
            },
            {
              icon: 'coleBuxton',
              name: 'Cole Buxton',
              path: '/clothing/cole-buxton/',
              type: 'brand'
            },
            {
              icon: 'corteiz',
              name: 'Corteiz',
              path: '/clothing/corteiz/',
              type: 'brand'
            },
            {
              icon: 'fearOfGod',
              name: 'Fear Of God ESSENTIALS',
              path: '/clothing/fear-of-god-essentials/',
              type: 'brand'
            },
            {
              icon: 'montirex',
              name: 'Montirex',
              path: '/clothing/montirex/',
              type: 'brand'
            },
            {
              icon: 'newBalance',
              name: 'New Balance',
              path: '/clothing/new-balance/',
              type: 'brand'
            },
            {
              icon: 'nike',
              name: 'Nike',
              path: '/clothing/nike/',
              type: 'brand'
            },
            {
              icon: 'represent',
              name: 'Represent',
              path: '/clothing/represent/',
              type: 'brand'
            },
            {
              icon: 'stussy',
              name: 'Stüssy',
              path: '/clothing/stussy/',
              type: 'brand'
            },
            {
              icon: 'theNorthFace',
              name: 'The North Face',
              path: '/clothing/the-north-face/',
              type: 'brand'
            },
            {
              icon: 'uniqlo',
              name: 'Uniqlo',
              path: '/clothing/uniqlo/',
              type: 'brand'
            }
          ],
          path: 'clothing'
        },
        filters: [
          {
            link: '/clothing/',
            title: "What's hot"
          },
          {
            link: '/clothing/?sort=release_date_desc',
            title: 'Latest releases'
          }
        ],
        icon: 'clothing',
        title: 'Clothing'
      },
      render: true
    },
    link: '/clothing/',
    name: 'Clothing',
    slug: 'clothing'
  },
  {
    link: '/sale/',
    name: 'Sale',
    slug: 'sale'
  },
  {
    link: '/news/',
    name: 'News',
    slug: 'news'
  }
];

export default headermenus;
